'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateFormatter = require('./DateFormatter');

var _DateFormatter2 = _interopRequireDefault(_DateFormatter);

var _time = require('../utils/time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateSwitcher = function (_Component) {
  (0, _inherits3.default)(DateSwitcher, _Component);

  function DateSwitcher(props) {
    (0, _classCallCheck3.default)(this, DateSwitcher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DateSwitcher.__proto__ || (0, _getPrototypeOf2.default)(DateSwitcher)).call(this, props));

    _this.state = {
      showCreatedAt: false
    };

    _this.toggleWaitTimeBound = _this.toggleWaitTime.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DateSwitcher, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'oe-date-switcher', onClick: this.toggleWaitTimeBound },
        this.state.showCreatedAt ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_DateFormatter2.default, { abbreviateMonth: true, date: this.props.date })
        ) : _react2.default.createElement(
          'span',
          null,
          this.props.extraText,
          ' ',
          (0, _time.getAverageWaitTime)((0, _time.getDifferenceInMinutesToNow)(this.props.date))
        )
      );
    }
  }, {
    key: 'toggleWaitTime',
    value: function toggleWaitTime(e) {
      e.stopPropagation();
      this.setState({
        showCreatedAt: !this.state.showCreatedAt
      });
    }
  }]);
  return DateSwitcher;
}(_react.Component);

exports.default = DateSwitcher;


DateSwitcher.propTypes = {
  date: _propTypes2.default.number,
  extraText: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@opportunityeducation/oe-web-common/dist/components/DateSwitcher.js
// module id = 1390
// module chunks = 0